import { request } from "../../utils/request";

/**
 * 支付接口（按 doc/支付接口.json 重写）。
 *
 * - 新 API 入参为 `packageId`（套餐 ID），不再传金额
 * - 新增响应字段 `qrCodeImage`（Base64 二维码）
 * - 支付状态明确枚举：pending / success / failed / closed
 */

export type PayApiChannel = "wechat_native" | "alipay_qrcode";

/** 新接口入参：POST /pay/create（doc/支付接口.json） */
export interface AppPaymentCreateReqVO {
  packageId: number;
  payChannel: PayApiChannel;
  userId: number;
}

/** 新接口响应 data：POST /pay/create */
export interface AppPaymentCreateRespVO {
  rechargeNo: string;
  codeUrl: string;
  qrCodeImage: string;
  amount: number;
  payChannel: string;
  point: number;
  bonusPoint: number;
}

/** 新接口响应 data：GET /pay/query */
export interface AppPaymentStatusRespVO {
  rechargeNo: string;
  paymentStatus: "pending" | "success" | "failed" | "closed";
}

interface CommonResult<T> {
  code: number;
  data: T;
  msg: string;
}

/** POST /pay/create — 创建支付订单，返回二维码 */
export const createAppPaymentOrderApi = (
  body: AppPaymentCreateReqVO
): Promise<CommonResult<AppPaymentCreateRespVO>> =>
  request<CommonResult<AppPaymentCreateRespVO>>("/pay/create", {
    method: "POST",
    body,
  });

/** GET /pay/query?rechargeNo=... — 查询支付状态（前端轮询） */
export const queryAppPaymentStatusApi = (
  rechargeNo: string
): Promise<CommonResult<AppPaymentStatusRespVO>> =>
  request<CommonResult<AppPaymentStatusRespVO>>("/pay/query", {
    method: "GET",
    params: { rechargeNo },
  });

/** 新规范：仅 `success` 为支付成功 */
export const isAppPaymentSuccess = (
  status: string | null | undefined
): boolean => status === "success";